export default {
  title: 'Sigur doriți să vă deconectați?',
  buttons: {
    logout: 'Deconectați-vă',
    cancel: 'Anulați',
  },
};
